module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-PC.ced0a837.png";